import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentRuntimeProvider {
  
  /**
   * Inicializa o environment com as variáveis de runtime
   * Este método é chamado durante a inicialização da aplicação
   */
  initialize(): Promise<void> {
    return new Promise((resolve) => {
      try {
        // Obter as variáveis de runtime do window
        const runtimeEnvironment = (window as any).__RUNTIME_ENVIRONMENT__;
        
        if (runtimeEnvironment && typeof runtimeEnvironment === 'object') {
          console.log('[EnvironmentRuntimeProvider] Aplicando variáveis de runtime:', runtimeEnvironment);
          
          // Substituir propriedades do environment com as do runtime
          this.mergeEnvironmentWithRuntime(environment, runtimeEnvironment);
          
          console.log('[EnvironmentRuntimeProvider] Environment atualizado:', environment);
        } else {
          console.log('[EnvironmentRuntimeProvider] Nenhuma variável de runtime encontrada, usando environment padrão');
        }
        
        resolve();
      } catch (error) {
        console.error('[EnvironmentRuntimeProvider] Erro ao inicializar environment:', error);
        // Mesmo com erro, resolve para não bloquear a inicialização da app
        resolve();
      }
    });
  }
  
  /**
   * Mescla recursivamente as propriedades do runtime com o environment
   */
  private mergeEnvironmentWithRuntime(target: any, source: any): void {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        const sourceValue = source[key];
        
        if (sourceValue !== null && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
          // Se é um objeto, fazer merge recursivo
          if (!target[key] || typeof target[key] !== 'object') {
            target[key] = {};
          }
          this.mergeEnvironmentWithRuntime(target[key], sourceValue);
        } else {
          // Converter strings "true"/"false" para boolean quando apropriado
          if (typeof sourceValue === 'string') {
            if (sourceValue.toLowerCase() === 'true') {
              target[key] = true;
            } else if (sourceValue.toLowerCase() === 'false') {
              target[key] = false;
            } else {
              target[key] = sourceValue;
            }
          } else {
            target[key] = sourceValue;
          }
        }
      }
    }
  }
  
  /**
   * Método utilitário para obter o environment atual (já mesclado)
   */
  getEnvironment(): any {
    return environment;
  }
  
  /**
   * Método utilitário para obter uma propriedade específica do environment
   */
  getEnvironmentProperty(path: string): any {
    return this.getNestedValue(environment, path);
  }
  
  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => current?.[key], obj);
  }
}